import * as React from "react"
import { Box } from "@mui/material"
import { formatProductsUnits } from "@ui-seeker/utils"

import { HierarchicalTextBlock, ImageSkuBlock, SkuInfoBlock } from "@components"
import { useAdminScrapingDataReviewList } from "../../../@hooks"


export default function productRawColumn(hideNumItems=false) {
    return [{
        name: "productID", label: "Product ID",
        options: {
            filterType: "textField",
            display: "excluded"
        }
    }, {
        name: "brandRaw", label: "Brand Raw",
        options: {
            filterType: "textField",
            display: "excluded"
        }
    }, {
        name: "productTitle", label: "Product Raw",
        options: {
            filterType: "textField",
            setCellProps: () => ({ sx: {
                whiteSpace: "nowrap",
                position: "sticky",
                minWidth: 300,
                left: 110,
                backgroundColor: "white",
                zIndex: "100",
                borderRight: "1px solid",
                borderColor: "divider"
            }}),
            setCellHeaderProps: () => ({ sx: {
                whiteSpace: "nowrap",
                position: "sticky",
                left: 110,
                backgroundColor: "white",
                zIndex: "101 !important",
                borderRight: "1px solid",
                borderColor: "divider"
            }}),
            customBodyRowRenderLite: (value, rowData) => <ProductRowCell
                productName={value}
                rowData={rowData}
                hideNumItems={hideNumItems}
            />
        }
    }]
}

const ProductRowCell = ({ productName, rowData, hideNumItems }) => {
    const { isOpenDrawer, isOpenNumItemsTable, handleClickDetails, handleClickNumItems } = useAdminScrapingDataReviewList(rowData)

    const isOpenDrawerClass = isOpenDrawer ? "is-open" : ""
    const isOpenNumItemsTableClass = isOpenNumItemsTable && !hideNumItems ? "is-open-num-items" : ""

    const numItems = rowData.itemsNum
    const isClickable = numItems > 1
    
    return <Box className={`${isOpenDrawerClass} ${isOpenNumItemsTableClass}`} display="flex" alignItems="center" justifyContent="flex-start"> 
        <ImageSkuBlock 
            imageURL={rowData.thumbnail} 
            name={productName} 
            hideName 
            imageProps={{ minWidth:50, minHeight: 50 }} 
            contentProps={{ sx: { margin: "", mr: 3 } }}
        />
        <Box display="flex" flexDirection="column">
            {!hideNumItems && <Box onClick={isClickable ? handleClickNumItems : null}>
                <HierarchicalTextBlock
                    title="No. items: "
                    titleValue={formatProductsUnits(numItems)}
                    sx={ isClickable ? { textDecoration: "underline", cursor: "pointer" } : {} }
                />
            </Box>}
            <HierarchicalTextBlock title="Product ID: " titleValue={rowData.productID} />
            <HierarchicalTextBlock title="Brand raw: " titleValue={rowData.brandRaw} />
            <SkuInfoBlock
                sku={rowData.productName}
                productURL={rowData.productUrl}
                displayShowDetails
                ellipsis
                onClick={handleClickDetails}
            />
        </Box>
    </Box>
}